// extracted by mini-css-extract-plugin
export default {"actionBlocks":"CommonPopper_actionBlocks__oXcAf","actionBox":"CommonPopper_actionBox__njgNf"};